import Lottie from 'react-lottie';
import flameAnimation from '../../animations/flame.json';

export function FlameIcon({ streak }) {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: flameAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };

    return (
        <div className="streak-container" title={`Streak: ${streak}`}>
            <div className="flame-wrapper">
                <Lottie
                    options={defaultOptions}
                    height={44}
                    width={44}
                />
                <span className="streak-number">{streak}</span>
            </div>
        </div>
    );
};
